import React, { createContext, useContext } from 'react';
import { Platform } from 'react-native';

const FontFamilyContext = createContext(null);

/** A web-only default; an explicit fontFamily on Text still takes precedence. */
export function FontFamilyProvider({ fontFamily, children }) {
  return <FontFamilyContext.Provider value={fontFamily}>
    {children}
  </FontFamilyContext.Provider>;
}

export function useFontFamily() {
  const fontFamily = useContext(FontFamilyContext);
  return Platform.OS === 'web' ? fontFamily : null;
}
